<template>
  <div class="OwnerAppadvertisingadd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{detail.rtnhouse}}</el-button>
      </div>
      <el-form ref="addApp" :model="ruleForm" :rules="rules" label-width="200px" @submit.native.prevent class="form">
        <!-- 项目二维码 -->
				<el-form-item label="项目二维码：" v-if="flag == 0" style="position:relative">
					<div class="qrcode" ref="qrCodeUrl"></div>
				</el-form-item>
        <el-form-item label="所属区域" prop="gardenArea">
          <el-select class="select" v-model="ruleForm.gardenArea" placeholder="请选择所属区域">
            <el-option label="润城住宅一部" value="润城住宅一部"></el-option>
            <el-option label="润城住宅二部" value="润城住宅二部"></el-option>
            <el-option label="润城商业一部" value="润城商业一部"></el-option>
            <el-option label="润城商业二部" value="润城商业二部"></el-option>
            <el-option label="长水一部" value="长水一部"></el-option>
            <el-option label="长水二部" value="长水二部"></el-option>
            <el-option label="长水三部" value="长水三部"></el-option>
            <el-option label="山水润城" value="山水润城"></el-option>
            <el-option label="版纳项目" value="版纳项目"></el-option>
            <el-option label="公建及案场项目部" value="公建及案场项目部"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.houseName" prop="name">
          <el-input maxlength="20" class="select" v-model="ruleForm.name" :placeholder="detail.writeName"></el-input>
        </el-form-item>
        <el-form-item :label="detail.province" prop="provinces">
          <el-select class="select" @change="selectcity" v-model="ruleForm.provinces" :placeholder="detail.choosep">
            <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.city" prop="cityId">
          <el-select class="select" @change="choosecitys" v-model="ruleForm.cityId" :placeholder="detail.choosec">
            <el-option v-for="item in choosecity" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.onlyopen" prop="onlyOpenDoor">
          <el-select class="select" v-model="ruleForm.onlyOpenDoor">
            <el-option :label='detail.normal' key=1 value='1'></el-option>
            <el-option :label='detail.onlydoor' key=2 value='2'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.isshow" prop="isDisplay">
          <el-select class="select" v-model="ruleForm.isDisplay" placeholder="">
            <el-option :label='detail.show' key='1' value='1'></el-option>
            <el-option :label='detail.notshow' key='2' value='2'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.owndo" prop="adFlag">
          <el-radio-group v-model="ruleForm.adFlag">
            <el-radio label=0 key='0'>{{detail.yes}}</el-radio>
            <el-radio label=1 key='1'>{{detail.no}}</el-radio>
          </el-radio-group>
        </el-form-item>
		<el-form-item label="是否开启信用积分:" prop="openCredit">
		  <el-radio-group v-model="ruleForm.openCredit">
		    <el-radio label=1 key='1'>{{detail.yes}}</el-radio>
		    <el-radio label=0 key='0'>{{detail.no}}</el-radio>
		  </el-radio-group>
		</el-form-item>
		<el-form-item label="排序" prop="sortId">
		  <el-input-number style="width:200px !important;" :placeholder="$t('lang.lab_AdverSortText')" class="select"
		    :label="$t('lang.lab_AdverSortText')" v-model="ruleForm.sortId" controls-position="right"
			:min="0" :max="999"></el-input-number>
		    <el-tooltip class="item" effect="light" :content=sortIdTipFont placement="right">
		      <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
		    </el-tooltip>
		</el-form-item>
        <el-form-item :label="detail.housecode" prop="gardenCode">
          <el-input class="select" v-model="ruleForm.gardenCode" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="detail.carcode" prop="parkCode">
          <el-input class="select" v-model="ruleForm.parkCode" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="经度录入:" prop="longitude">
          <el-input class="select" v-model="ruleForm.longitude" placeholder="示例：116.407387"></el-input>
        </el-form-item>
        <el-form-item label="纬度录入:" prop="latitude">
          <el-input class="select" v-model="ruleForm.latitude" placeholder="示例：39.904179"></el-input>
        </el-form-item>
        <el-form-item label="所属公司:" prop="affiliatedCompany">
          <el-select
            class="select"
            v-model="ruleForm.affiliatedCompany"
            placeholder="请选择所属公司"
            clearable
            filterable
          >
            <el-option
              v-for="item in companyList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目编码:" prop="projectCode">
          <el-input class="select" v-model="ruleForm.projectCode" placeholder="请输入项目编码"></el-input>
        </el-form-item>
        <el-form-item label="经纬度拾取器链接：">
          <a href="https://lbs.amap.com/tools/picker" target="_blank">https://lbs.amap.com/tools/picker</a>
        </el-form-item>
        <el-form-item label="APP水印拍照字体颜色:" prop="themeColor">
          <div style="display: flex; align-items: center;">
            <el-color-picker v-model="ruleForm.themeColor" />
            <el-button type="text" @click="restoreDefaultThemeColor" size="small" style="margin-left: 10px;">恢复默认颜色</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="detail.gardenLogoType" prop="gardenLogoType">
          <el-radio-group v-model="ruleForm.gardenLogoType">
            <el-radio label="0" key='0'>{{detail.defaultLogo}}</el-radio>
            <el-radio label="1" key='1'>{{detail.customLogo}}</el-radio>
            <el-radio label="2" key='2'>{{detail.noLogo}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="qrcodeImg" v-if="this.ruleForm.gardenLogoType == '1'"
          :label="$t('lang.lab_uploadPhotograph')" prop="gardenLogo" ref="gardenLogo">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileList" :clears="clears"
            @outputFile="getFile" @removeFile="removeFile"></upload-file>
        </el-form-item>
        <!-- 收款码 -->
        <el-form-item class="qrcodeImg" label="上传收款码" prop="qrcodeImgUrl" ref="qrcodeImgUrl">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileList1" :clears="clears"
            @outputFile="getFile1" @removeFile="removeFile1"></upload-file>
          <!-- <upload-morefiles ref="uploading" :accept='accept' upTypes='1' :fileList='filesList1' :clears='clears'
                @outputFile="getFile1" @removeFile='removeFile1'></upload-morefiles> -->
        </el-form-item>
        <el-form-item style="margin-right:30px;" label="小区图片" prop="gardenPhoto" ref="gardenPhoto">
          <upload-morefile ref="uploading" :accept="accept" upTypes="1" :fileList="filesList10" :clears="clears"
            @outputFile="getFileGardenPhoto" @removeFile="removeFileGardenPhoto"></upload-morefile>
        </el-form-item>
        <!-- 简介 -->
        <el-form-item label="小区简介" prop="gardenInfo" class="editor-width">
          <el-input type="textarea" v-model="ruleForm.gardenInfo" :rows="2" class="replyCon"></el-input>
        </el-form-item>
        <!-- 交房日期 -->
        <el-form-item label="交房日期" prop="deliverDateL">
          <div>
            <el-date-picker v-model="ruleForm.deliverDateL" type="date" value-format="timestamp"
              placeholder="项目交房日期"></el-date-picker>
          </div>
        </el-form-item>
        <!-- 有效期 -->
        <el-form-item :label="$t('lang.lab_controlPeriod')" prop="gardenValid">
          <div>
            <el-date-picker v-model="ruleForm.gardenValid" type="date" value-format="timestamp"
              :placeholder="$t('lang.lab_controlPeriod')"></el-date-picker>
          </div>
        </el-form-item>
        <!-- 删除最后时限 -->
        <el-form-item label="删除最后时限" prop="gardenDeleteValid">
          <div>
            <el-date-picker v-model="ruleForm.gardenDeleteValid" type="date" value-format="timestamp"
              placeholder="删除最后时限"></el-date-picker>
              <span style="margin-left: 20px;color:#3A8DFC;">
                <i class="el-icon-warning"></i>
                拥有删除项目信息数据和原始住户数据权限的最后日期
              </span>
          </div>
        </el-form-item>
        <el-form-item label="员工人数（人）" prop="staffNum">
          <el-input class="select" v-model="ruleForm.staffNum" @input="handleInputInt(ruleForm.staffNum,'staffNum')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="建筑面积（平方米）" prop="floorArea">
          <el-input class="select" v-model="ruleForm.floorArea" @input="handleInputDec(ruleForm.floorArea,'floorArea')" placeholder="请输入正整数或2位小数"></el-input>
        </el-form-item>
        <el-form-item label="占地面积（平方米）" prop="coverArea">
          <el-input class="select" v-model="ruleForm.coverArea" @input="handleInputDec(ruleForm.coverArea,'coverArea')" placeholder="请输入正整数或2位小数"></el-input>
        </el-form-item>
        <el-form-item label="地上管理面积（平方米）" prop="onGroundArea">
          <el-input class="select" v-model="ruleForm.onGroundArea" @input="handleInputDec(ruleForm.onGroundArea,'onGroundArea')" placeholder="请输入正整数或2位小数"></el-input>
        </el-form-item>
        <el-form-item label="地下管理面积（平方米）" prop="unGroundArea">
          <el-input class="select" v-model="ruleForm.unGroundArea" @input="handleInputDec(ruleForm.unGroundArea,'unGroundArea')" placeholder="请输入正整数或2位小数"></el-input>
        </el-form-item>
        <el-form-item label="收费面积（平方米）" prop="feeArea">
          <el-input class="select" v-model="ruleForm.feeArea" @input="handleInputDec(ruleForm.feeArea,'feeArea')" placeholder="请输入正整数或2位小数"></el-input>
        </el-form-item>
        <el-form-item label="园区户数（户）" prop="houseHolds">
          <el-input class="select" v-model="ruleForm.houseHolds" @input="handleInputInt(ruleForm.houseHolds,'houseHolds')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="网点数量（个）" prop="outletsCount">
          <el-input class="select" v-model="ruleForm.outletsCount" @input="handleInputInt(ruleForm.outletsCount,'outletsCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="资源点位数量（个）" prop="venueCount">
          <el-input class="select" v-model="ruleForm.venueCount" @input="handleInputInt(ruleForm.venueCount,'venueCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="设备设施数量（个）" prop="deviceCount">
          <el-input class="select" v-model="ruleForm.deviceCount" @input="handleInputInt(ruleForm.deviceCount,'deviceCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="单人出入口数量（有人值守）" prop="peoExitCount">
          <el-input class="select" v-model="ruleForm.peoExitCount" @input="handleInputInt(ruleForm.peoExitCount,'peoExitCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="单人出入口数量（无人值守）" prop="nopeoExitCount">
          <el-input class="select" v-model="ruleForm.nopeoExitCount" @input="handleInputInt(ruleForm.nopeoExitCount,'nopeoExitCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="单车出入口数量（个）" prop="carExitCount">
          <el-input class="select" v-model="ruleForm.carExitCount" @input="handleInputInt(ruleForm.carExitCount,'carExitCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="人车混合出入口数量（个）" prop="mixExitCount">
          <el-input class="select" v-model="ruleForm.mixExitCount" @input="handleInputInt(ruleForm.mixExitCount,'mixExitCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="楼栋数量（栋）" prop="buildingsCount">
          <el-input class="select" v-model="ruleForm.buildingsCount" @input="handleInputInt(ruleForm.buildingsCount,'buildingsCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="单元数量（个）" prop="unitsCount">
          <el-input class="select" v-model="ruleForm.unitsCount" @input="handleInputInt(ruleForm.unitsCount,'unitsCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="电梯数量（部）" prop="liftCount">
          <el-input class="select" v-model="ruleForm.liftCount" @input="handleInputInt(ruleForm.liftCount,'liftCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="车位数量（个）" prop="parkCount">
          <el-input class="select" v-model="ruleForm.parkCount" @input="handleInputInt(ruleForm.parkCount,'parkCount')" placeholder="请输入正整数"></el-input>
        </el-form-item>
        <el-form-item label="物业费单价（元）" prop="feePrice">
          <el-input class="select" v-model="ruleForm.feePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="车位管理费（元）" prop="feeParkPrice">
          <el-input class="select" v-model="ruleForm.feeParkPrice" placeholder=""></el-input>
        </el-form-item>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="入住文件上传/下载" name="1">
            <el-form-item label="入住文件上传/下载" prop="urls3" ref="urls3">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList3' :clears='clears'
                @outputFile="getFile3" @removeFile='removeFile3'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="装修管理上传/下载" name="2">
            <el-form-item label="装修管理上传/下载" prop="urls4" ref="urls4">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList4' :clears='clears'
                @outputFile="getFile4" @removeFile='removeFile4'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="车位管理上传/下载" name="3">
            <el-form-item label="车位管理上传/下载" prop="urls5" ref="urls5">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList5' :clears='clears'
                @outputFile="getFile5" @removeFile='removeFile5'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="保险理赔上传/下载" name="4">
            <el-form-item label="保险理赔上传/下载" prop="urls6" ref="urls6">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList6' :clears='clears'
                @outputFile="getFile6" @removeFile='removeFile6'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="法律诉讼上传/下载" name="5">
            <el-form-item label="法律诉讼上传/下载" prop="urls7" ref="urls7">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList7' :clears='clears'
                @outputFile="getFile7" @removeFile='removeFile7'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="二手房交易上传/下载" name="6">
            <el-form-item label="二手房交易上传/下载" prop="urls8" ref="urls8">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList8' :clears='clears'
                @outputFile="getFile8" @removeFile='removeFile8'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="返修管理上传/下载" name="7">
            <el-form-item label="返修管理上传/下载" prop="urls9" ref="urls9">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList9' :clears='clears'
                @outputFile="getFile9" @removeFile='removeFile9'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="其它附件上传/下载" name="8">
            <el-form-item label="其它附件上传/下载" prop="urls" ref="urls">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList2' :clears='clears'
                @outputFile="getFile2" @removeFile='removeFile2'></upload-morefiles>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
        <!-- <el-form-item label="入住文件上传" prop="urls3" ref="urls3">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList3' @outputFile="getFile3"
						@removeFile='removeFile3'></upload-morefile>
				</el-form-item>
        <el-form-item label="入住文件下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls3"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="装修管理上传" prop="urls4" ref="urls4">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList4' @outputFile="getFile4"
						@removeFile='removeFile4'></upload-morefile>
				</el-form-item>
        <el-form-item label="装修管理下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls4"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="车位管理上传" prop="urls5" ref="urls5">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList5' @outputFile="getFile5"
						@removeFile='removeFile5'></upload-morefile>
				</el-form-item>
        <el-form-item label="车位管理下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls5"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="保险理赔上传" prop="urls6" ref="urls6">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList6' @outputFile="getFile6"
						@removeFile='removeFile6'></upload-morefile>
				</el-form-item>
        <el-form-item label="保险理赔下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls6"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="法律诉讼上传" prop="urls7" ref="urls7">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList7' @outputFile="getFile7"
						@removeFile='removeFile7'></upload-morefile>
				</el-form-item>
        <el-form-item label="法律诉讼下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls7"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="二手房交易上传" prop="urls8" ref="urls8">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList8' @outputFile="getFile8"
						@removeFile='removeFile8'></upload-morefile>
				</el-form-item>
        <el-form-item label="二手房交易下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls8"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
          </el-form-item>

        <el-form-item label="其它附件上传" prop="urls" ref="urls">
					<upload-morefile ref="uploading" :accept='accept2' upTypes='2' :fileList='filesList2' @outputFile="getFile2"
						@removeFile='removeFile2'></upload-morefile>
				</el-form-item>
        <el-form-item label="其它附件下载">
              <a
                class="btnmar" target="_blank"
                :href="src.split('|')[0]"
                v-for="(src,index) in this.ruleForm.urls"
                :key="index"
                download
              >{{src.split('|')[1]}}<br/></a>
        </el-form-item> -->
        <el-form-item :label="detail.isLiftControl" prop="isLiftControl">
          <el-radio-group v-model="ruleForm.isLiftControl">
            <el-radio label=1 key='1'>{{detail.yes}}</el-radio>
            <el-radio label=0 key='0'>{{detail.no}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="门禁是否分享" prop="isShareDoor">
          <el-radio-group v-model="ruleForm.isShareDoor">
            <el-radio label=1 key='1'>{{detail.yes}}</el-radio>
            <el-radio label=0 key='0'>{{detail.no}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="梯控是否分享" prop="isShareLift">
          <el-radio-group v-model="ruleForm.isShareLift">
            <el-radio label=1 key='1'>{{detail.yes}}</el-radio>
            <el-radio label=0 key='0'>{{detail.no}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 本期目标值 -->
				<el-card class="garden" v-if="flag==0">
					<el-collapse>
						<el-form-item :label="$t('lang.lab_targetFeeGardenValue')">
							<el-collapse-item>
								<el-form-item class="targetLabel" label="年份">
									<el-date-picker @change="changeYear()" v-model="form.targetYear" type="year"
										:placeholder="$t('lang.lab_changeYear')">
									</el-date-picker>
								</el-form-item>
								<el-form-item v-show="form.targetYear">
									<el-form-item class="targetLabel" label="1月">
										<el-input @input=targetKeyup1() class="targetMonth" v-model="form.month1"
											:placeholder="$t('lang.lab_targetMonth1')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="2月">
										<el-input @input=targetKeyup2() class="targetMonth" v-model="form.month2"
											:placeholder="$t('lang.lab_targetMonth2')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="3月">
										<el-input @input=targetKeyup3() class="targetMonth" v-model="form.month3"
											:placeholder="$t('lang.lab_targetMonth3')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="4月">
										<el-input @input=targetKeyup4() class="targetMonth" v-model="form.month4"
											:placeholder="$t('lang.lab_targetMonth4')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="5月">
										<el-input @input=targetKeyup5() class="targetMonth" v-model="form.month5"
											:placeholder="$t('lang.lab_targetMonth5')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="6月">
										<el-input @input=targetKeyup6() class="targetMonth" v-model="form.month6"
											:placeholder="$t('lang.lab_targetMonth6')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="7月">
										<el-input @input=targetKeyup7() class="targetMonth" v-model="form.month7"
											:placeholder="$t('lang.lab_targetMonth7')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="8月">
										<el-input @input=targetKeyup8() class="targetMonth" v-model="form.month8"
											:placeholder="$t('lang.lab_targetMonth8')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="9月">
										<el-input @input=targetKeyup9() class="targetMonth" v-model="form.month9"
											:placeholder="$t('lang.lab_targetMonth9')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="10月">
										<el-input @input=targetKeyup10() class="targetMonth" v-model="form.month10"
											:placeholder="$t('lang.lab_targetMonth10')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="11月">
										<el-input @input=targetKeyup11() class="targetMonth" v-model="form.month11"
											:placeholder="$t('lang.lab_targetMonth11')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="12月">
										<el-input @input=targetKeyup12() class="targetMonth" v-model="form.month12"
											:placeholder="$t('lang.lab_targetMonth12')"></el-input>
									</el-form-item>
								</el-form-item>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<br />
        <!-- 拖欠目标值 -->
				<el-card class="garden">
					<el-collapse>
						<el-form-item :label="$t('lang.lab_targetFeeGardenArrearsValue')">
							<el-collapse-item>
								<el-form-item class="targetLabel" label="年份">
									<el-date-picker @change="changeFeeYear()" v-model="feeForm.targetYear" type="year"
										:placeholder="$t('lang.lab_changeYear')">
									</el-date-picker>
								</el-form-item>
								<el-form-item v-show="feeForm.targetYear">
									<el-form-item class="targetLabel" label="1月">
										<el-input @input=targetFeeKeyup1() class="targetMonth" v-model="feeForm.month1"
											:placeholder="$t('lang.lab_targetMonth1')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="2月">
										<el-input @input=targetFeeKeyup2() class="targetMonth" v-model="feeForm.month2"
											:placeholder="$t('lang.lab_targetMonth2')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="3月">
										<el-input @input=targetFeeKeyup3() class="targetMonth" v-model="feeForm.month3"
											:placeholder="$t('lang.lab_targetMonth3')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="4月">
										<el-input @input=targetFeeKeyup4() class="targetMonth" v-model="feeForm.month4"
											:placeholder="$t('lang.lab_targetMonth4')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="5月">
										<el-input @input=targetFeeKeyup5() class="targetMonth" v-model="feeForm.month5"
											:placeholder="$t('lang.lab_targetMonth5')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="6月">
										<el-input @input=targetFeeKeyup6() class="targetMonth" v-model="feeForm.month6"
											:placeholder="$t('lang.lab_targetMonth6')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="7月">
										<el-input @input=targetFeeKeyup7() class="targetMonth" v-model="feeForm.month7"
											:placeholder="$t('lang.lab_targetMonth7')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="8月">
										<el-input @input=targetFeeKeyup8() class="targetMonth" v-model="feeForm.month8"
											:placeholder="$t('lang.lab_targetMonth8')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="9月">
										<el-input @input=targetFeeKeyup9() class="targetMonth" v-model="feeForm.month9"
											:placeholder="$t('lang.lab_targetMonth9')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="10月">
										<el-input @input=targetFeeKeyup10() class="targetMonth" v-model="feeForm.month10"
											:placeholder="$t('lang.lab_targetMonth10')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="11月">
										<el-input @input=targetFeeKeyup11() class="targetMonth" v-model="feeForm.month11"
											:placeholder="$t('lang.lab_targetMonth11')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="12月">
										<el-input @input=targetFeeKeyup12() class="targetMonth" v-model="feeForm.month12"
											:placeholder="$t('lang.lab_targetMonth12')"></el-input>
									</el-form-item>
								</el-form-item>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<br />
        <el-button class="btn-first" @click="resetForm">{{this.$i18n.t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" :disabled='false' type="primary" @click="onSubmit">
          {{this.$i18n.t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:OwnerAppadvertisingadd
   *@Description:小区管理新增编辑
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-27
   */
  import QRCode from 'qrcodejs2'
  import UploadFile from '../../../components/upload_file.vue'
  import uploadmoreFile from '../../../components/upload_morefile.vue'
  import uploadmoreFiles from '../../../components/upload_morefiles.vue'
  export default {
    data() {
      return {
		sortIdTipFont: '0-999排序数字越大，项目展示越靠前。',
        companyList: [
          { code: '10', name: '润晟生活服务有限公司' },
          { code: '1001', name: '昆明怡和物业服务有限公司' },
          { code: '1002', name: '昆明润家餐饮服务有限公司' },
          { code: '1003', name: '昆明润家餐饮服务有限公司长水分公司' },
          { code: '1004', name: '昆明润格清洁服务有限公司' },
          { code: '1005', name: '昆明润格清洁服务有限公司润城分公司' },
          { code: '1006', name: '云南润元商业运营管理有限公司' },
          { code: '1007', name: '云南润杰生活服务有限公司' },
          { code: '1008', name: '云南瑞润消防科技有限责任公司' },
          { code: '1009', name: '香格里拉市保御物业管理有限责任公司' },
          { code: '1010', name: '保山易乐怡和物业管理有限公司' },
          { code: '1011', name: '西双版纳怡和物业服务有限公司' },
          { code: '1012', name: '云南润悦生活服务有限公司' },
          { code: '1013', name: '云南润明商务管理有限公司' },
          { code: '1014', name: '云南润都市场管理有限公司' },
          { code: '1015', name: '云南吾乡酒店管理有限公司' },
          { code: '1016', name: '深圳前海润晟城市生活服务有限公司' },
          { code: '1017', name: '云南众煌建筑工程有限公司' }
        ],
        feeForm: {
					targetYear: '', // 目标年份
					month1: 0, // 1月目标值
					month2: 0, // 2月目标值
					month3: 0, // 3月目标值
					month4: 0, // 4月目标值
					month5: 0, // 5月目标值
					month6: 0, // 6月目标值
					month7: 0, // 7月目标值
					month8: 0, // 8月目标值
					month9: 0, // 9月目标值
					month10: 0, // 10月目标值
					month11: 0, // 11月目标值
					month12: 0, // 12月目标值
				},  
        form: {
					targetYear: '', // 目标年份
					month1: 0, // 1月目标值
					month2: 0, // 2月目标值
					month3: 0, // 3月目标值
					month4: 0, // 4月目标值
					month5: 0, // 5月目标值
					month6: 0, // 6月目标值
					month7: 0, // 7月目标值
					month8: 0, // 8月目标值
					month9: 0, // 9月目标值
					month10: 0, // 10月目标值
					month11: 0, // 11月目标值
					month12: 0, // 12月目标值
				},  
        activeName: '1',
        saveData: '',
        isTrue: false,
        isAddTrue: false,
        isCanUse: true,
        id: '',
        radio: '1',
        // value: '',
        name: '',
        choosecity: [],
        provinces: [], // 保存省份对应的城市
        tableData: [], // 全部小区
        accept: '.jpg, .jpeg, .png',
        accept2: '*.*',
        clears: false, // 清空按钮
        fileList: [], // 文件列表
        fileList1: [], // 收款码文件列表
        fileList2: [], // 文件列表
        filesList2: [],
        fileList3: [], // 文件列表
        filesList3: [],
        fileList4: [], // 文件列表
        filesList4: [],
        fileList5: [], // 文件列表
        filesList5: [],
        fileList6: [], // 文件列表
        filesList6: [],
        fileList7: [], // 文件列表
        filesList7: [],
        fileList8: [], // 文件列表
        filesList8: [],
        fileList9: [], // 文件列表
        filesList9: [],
        fileList10: [], // 文件列表
        filesList10: [], // 文件列表
        flag: '', // 存储上一页传递的flag用于保存按按钮事件同上变量
        ruleForm: {
          id: '',
          adFlag: '0', // 是否独立运行
		  openCredit: '0', // 是否开启信用积分
          onlyOpenDoor: '1', // 开门权限
          isDisplay: '', // 业主端是否显示
          isLiftControl: '1', // 一键乘梯
          isShareDoor: '1', // 门禁是否分享
          isShareLift: '1', // 梯控是否分享
          name: '', // 小区名称
          provinces: '', // 省份
          gardenCode: '', // 小区编码
		  sortId: 0, // 排序
          parkCode: '', // 停车场编码
          gardenLogo: '', // 图片链接
          qrcodeImgUrl: '', // 收款码图片链接
          gardenLogoType: '0', // 类型
          urls: [], // 上传图片
          urls3: [], // 上传图片
          urls4: [], // 上传图片
          urls5: [], // 上传图片
          urls6: [], // 上传图片
          urls7: [], // 上传图片
          urls8: [], // 上传图片
          urls9: [], // 上传图片
          cityId: '', // 城市id
          longitude: '', // 经度
          latitude: '', // 纬度
          affiliatedCompany: '', // 所属公司编码
          projectCode: '', // 项目编码
          themeColor: '#365c9d', // 主题颜色
          gardenPhoto: [], // 小区图片
          deliverDateL: '', // 交房日期
          gardenValid: this.getTime(), // 小区有效期
          gardenDeleteValid: this.getThirtyTime(), // 删除最后时限
          floorArea: '', // 占地面积
          coverArea: '', // 建筑面积
          outletsCount: '', // 网点数量
          venueCount: '', // 资源点位数量
          deviceCount: '', // 设备设施数量
          onGroundArea: '', // 管理面积（地上）
          unGroundArea: '', // 管理面积（地下）
          feeArea: '', // 收费面积
          staffNum: '', // 员工人数
          buildingsCount: '', // 楼栋数量
          unitsCount: '', // 单元数量
          peoExitCount: '', // 单人出入口数量（有人值守）
          nopeoExitCount: '', // 单人出入口数量（无人值守）
          carExitCount: '', // 单车出入口
          mixExitCount: '', // 人车混行出入口
          houseHolds: '', // 园区户数(实际房间数)
          liftCount: '', // 电梯数量
          parkCount: '', // 车位数量(地上/地下)
          feePrice: '', // 物业费单价(高层/洋房/网点)
          feeParkPrice: '', // 车位管理费(月)
          gardenInfo: '', // 小区信息
          gardenArea: '', // 添加区域字段
        },
        choose: {
          name: '',
        },
        rules: {
          adFlag: [{
            required: false,
            message: this.$i18n.t('lang.housearea.owndo'),
            trigger: 'blur'
          }],
          cityId: [{
            required: true,
            message: this.$i18n.t('lang.housearea.choosec'),
            trigger: 'blur'
          }],
          onlyOpenDoor: [{
            required: true,
            message: this.$i18n.t('lang.housearea.onlyopen'),
            trigger: 'blur'
          }],
          isDisplay: [{
            required: false,
            message: this.$i18n.t('lang.housearea.isshow'),
            trigger: 'blur'
          }],
          isLiftControl: [{
            required: false,
            message: this.$i18n.t('lang.housearea.isLiftControl'),
            trigger: 'blur'
          }],
          isShareDoor: [{
            required: false,
            message: '',
            trigger: 'blur'
          }],
          isShareLift: [{
            required: false,
            message: '',
            trigger: 'blur'
          }],
          gardenLogoType: [{
            required: false,
            message: this.$i18n.t('lang.housearea.gardenLogoType'),
            trigger: 'blur'
          }],
          gardenLogo: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          provinces: [{
            required: true,
            message: this.$i18n.t('lang.housearea.choosep'),
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: this.$i18n.t('lang.housearea.writeName'),
            trigger: 'blur'
          }],
          longitude: [{
            required: true,
            message: '请输入经度',
            trigger: 'blur'
          }, {
            pattern: /^(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/,
            message: '请输入正确的经度',
            trigger: 'blur'
          }],
          latitude: [{
            required: true,
            message: '请输入纬度',
            trigger: 'blur'
          }, {
            pattern: /^((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/,
            message: '请输入正确的纬度',
            trigger: 'blur'
          }],
          affiliatedCompany: [{
            required: true,
            message: '请选择所属公司',
            trigger: 'change'
          }],
          projectCode: [{
            required: true,
            message: '请输入项目编码',
            trigger: 'blur'
          }],
          gardenValid: [{
            required: true,
            message: '请选择到期日期',
            trigger: 'change'
          }],
          gardenDeleteValid: [{
            required: true,
            message: '请选择最后日期',
            trigger: 'change'
          }],
          gardenArea: [{
            required: true,
            message: '请选择所属区域',
            trigger: 'change'
          }],
        },
        cities: require('@/config/cityAll').cities.provinces, // 查询
        detail: this.$i18n.t('lang.housearea'),
      }
    },
    components: {
      'upload-file': UploadFile,
      'upload-morefile': uploadmoreFile,
      'upload-morefiles': uploadmoreFiles
    },
    destroyed() {
      window.localStorage.setItem('xqform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('xqsaveData', JSON.stringify(this.saveData))
    },
    created() {
      if (window.localStorage.getItem('xqform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('xqform'))
        this.saveData = JSON.parse(window.localStorage.getItem('xqsaveData'))
        if (this.ruleForm.gardenLogo) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.gardenLogo
          })
        }
        if (this.ruleForm.qrcodeImgUrl) {
          this.fileList1.push({
            name: '',
            url: this.ruleForm.qrcodeImgUrl
          })
        }
        if (this.ruleForm.urls) {
          this.filesList2.push({
            name: '',
            url: this.ruleForm.urls
          })
        }
        if (this.ruleForm.urls3) {
          this.filesList3.push({
            name: '',
            url: this.ruleForm.urls3
          })
        }
        if (this.ruleForm.urls4) {
          this.filesList4.push({
            name: '',
            url: this.ruleForm.urls4
          })
        }
        if (this.ruleForm.urls5) {
          this.filesList5.push({
            name: '',
            url: this.ruleForm.urls5
          })
        }
        if (this.ruleForm.urls6) {
          this.filesList6.push({
            name: '',
            url: this.ruleForm.urls6
          })
        }
        if (this.ruleForm.urls7) {
          this.filesList7.push({
            name: '',
            url: this.ruleForm.urls7
          })
        }
        if (this.ruleForm.urls8) {
          this.filesList8.push({
            name: '',
            url: this.ruleForm.urls8
          })
        }
        if (this.ruleForm.urls9) {
          this.filesList9.push({
            name: '',
            url: this.ruleForm.urls9
          })
        }
        if (this.ruleForm.gardenPhoto && this.ruleForm.gardenPhoto.length > 0) {
          let resUrls = this.ruleForm.gardenPhoto.split(',')
          for (let i = 0; i < resUrls.length; i++) {
            this.fileList10.push({
              name: '',
              url: resUrls[i]
            })
          }
        }
        this.filesList10 = JSON.parse(JSON.stringify(this.fileList10))
      } else {
        this.flag = this.$route.query.flag
        this.fileList = []
        this.fileList1 = []
        this.fileList2 = []
        this.fileList3 = []
        this.fileList4 = []
        this.fileList5 = []
        this.fileList6 = []
        this.fileList7 = []
        this.fileList8 = []
        this.fileList9 = []
        this.fileList10 = []
        this.separate()
        if (this.flag == 0) {
          this.findProvince()
        }
      }
    },

    methods: {
      // 生成设备二维码
			creatQrCode() {
        let that = this
        console.log(that.ruleForm.complainUrl)
				let qrcode = new QRCode(that.$refs.qrCodeUrl, {
					text: that.ruleForm.complainUrl, // 需要转换为二维码的内容
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
				console.log(qrcode)
			},
      changeFeeYear() {
				if (this.id && this.feeForm.targetYear) {
					let date = new Date(this.feeForm.targetYear)
					let year = date.getFullYear()
					let loading = this.$loading()
					this.$get(`/feeGardenTargetByStaffYear`, {
						gardenId: this.id,
						targetYear: year,
            type:2
					}).then(res => {
						loading.close()
						if (res.errCode == 0) {
							this.$set(this.feeForm, 'month1', res.targetAmount1 == 0 ? '' : res.targetAmount1)
							this.$set(this.feeForm, 'month2', res.targetAmount2 == 0 ? '' : res.targetAmount2)
							this.$set(this.feeForm, 'month3', res.targetAmount3 == 0 ? '' : res.targetAmount3)
							this.$set(this.feeForm, 'month4', res.targetAmount4 == 0 ? '' : res.targetAmount4)
							this.$set(this.feeForm, 'month5', res.targetAmount5 == 0 ? '' : res.targetAmount5)
							this.$set(this.feeForm, 'month6', res.targetAmount6 == 0 ? '' : res.targetAmount6)
							this.$set(this.feeForm, 'month7', res.targetAmount7 == 0 ? '' : res.targetAmount7)
							this.$set(this.feeForm, 'month8', res.targetAmount8 == 0 ? '' : res.targetAmount8)
							this.$set(this.feeForm, 'month9', res.targetAmount9 == 0 ? '' : res.targetAmount9)
							this.$set(this.feeForm, 'month10', res.targetAmount10 == 0 ? '' : res.targetAmount10)
							this.$set(this.feeForm, 'month11', res.targetAmount11 == 0 ? '' : res.targetAmount11)
							this.$set(this.feeForm, 'month12', res.targetAmount12 == 0 ? '' : res.targetAmount12)
						}
					}, err => {
						this.$message.error(err)
					})
				} else {
					this.feeForm.month1 = ''
					this.feeForm.month2 = ''
					this.feeForm.month3 = ''
					this.feeForm.month4 = ''
					this.feeForm.month5 = ''
					this.feeForm.month6 = ''
					this.feeForm.month7 = ''
					this.feeForm.month8 = ''
					this.feeForm.month9 = ''
					this.feeForm.month10 = ''
					this.feeForm.month11 = ''
					this.feeForm.month12 = ''
				}
			},
      changeYear() {
				if (this.id && this.form.targetYear) {
					let date = new Date(this.form.targetYear)
					let year = date.getFullYear()
					let loading = this.$loading()
					this.$get(`/feeGardenTargetByStaffYear`, {
						gardenId: this.id,
						targetYear: year,
            type:1
					}).then(res => {
						loading.close()
						if (res.errCode == 0) {
							this.$set(this.form, 'month1', res.targetAmount1 == 0 ? '' : res.targetAmount1)
							this.$set(this.form, 'month2', res.targetAmount2 == 0 ? '' : res.targetAmount2)
							this.$set(this.form, 'month3', res.targetAmount3 == 0 ? '' : res.targetAmount3)
							this.$set(this.form, 'month4', res.targetAmount4 == 0 ? '' : res.targetAmount4)
							this.$set(this.form, 'month5', res.targetAmount5 == 0 ? '' : res.targetAmount5)
							this.$set(this.form, 'month6', res.targetAmount6 == 0 ? '' : res.targetAmount6)
							this.$set(this.form, 'month7', res.targetAmount7 == 0 ? '' : res.targetAmount7)
							this.$set(this.form, 'month8', res.targetAmount8 == 0 ? '' : res.targetAmount8)
							this.$set(this.form, 'month9', res.targetAmount9 == 0 ? '' : res.targetAmount9)
							this.$set(this.form, 'month10', res.targetAmount10 == 0 ? '' : res.targetAmount10)
							this.$set(this.form, 'month11', res.targetAmount11 == 0 ? '' : res.targetAmount11)
							this.$set(this.form, 'month12', res.targetAmount12 == 0 ? '' : res.targetAmount12)
						}
					}, err => {
						this.$message.error(err)
					})
				} else {
					this.form.month1 = ''
					this.form.month2 = ''
					this.form.month3 = ''
					this.form.month4 = ''
					this.form.month5 = ''
					this.form.month6 = ''
					this.form.month7 = ''
					this.form.month8 = ''
					this.form.month9 = ''
					this.form.month10 = ''
					this.form.month11 = ''
					this.form.month12 = ''
				}
			},
      targetFeeKeyup1() {
				// 仅保留数字和"."
				this.feeForm.month1 = this.feeForm.month1.replace(/[^0-9.]/g, "")
				// 首位是0的话去掉
				if (this.feeForm.month1.indexOf('.') < 0 && this.feeForm.month1 != '') {
					this.feeForm.month1 = parseFloat(this.feeForm.month1)
				}
			},
			targetFeeKeyup2() {
				this.feeForm.month2 = this.feeForm.month2.replace(/[^0-9.]/g, "")
				if (this.feeForm.month2.indexOf('.') < 0 && this.feeForm.month2 != '') {
					this.feeForm.month2 = parseFloat(this.feeForm.month2)
				}
			},
			targetFeeKeyup3() {
				this.feeForm.month3 = this.feeForm.month3.replace(/[^0-9.]/g, "")
				if (this.feeForm.month3.indexOf('.') < 0 && this.feeForm.month3 != '') {
					this.feeForm.month3 = parseFloat(this.feeForm.month3)
				}
			},
			targetFeeKeyup4() {
				this.feeForm.month4 = this.feeForm.month4.replace(/[^0-9.]/g, "")
				if (this.feeForm.month4.indexOf('.') < 0 && this.feeForm.month4 != '') {
					this.feeForm.month4 = parseFloat(this.feeForm.month4)
				}
			},
			targetFeeKeyup5() {
				this.feeForm.month5 = this.feeForm.month5.replace(/[^0-9.]/g, "")
				if (this.feeForm.month5.indexOf('.') < 0 && this.feeForm.month5 != '') {
					this.feeForm.month5 = parseFloat(this.feeForm.month5)
				}
			},
			targetFeeKeyup6() {
				this.feeForm.month6 = this.feeForm.month6.replace(/[^0-9.]/g, "")
				if (this.feeForm.month6.indexOf('.') < 0 && this.feeForm.month6 != '') {
					this.feeForm.month6 = parseFloat(this.feeForm.month6)
				}
			},
			targetFeeKeyup7() {
				this.feeForm.month7 = this.feeForm.month7.replace(/[^0-9.]/g, "")
				if (this.feeForm.month7.indexOf('.') < 0 && this.feeForm.month7 != '') {
					this.feeForm.month7 = parseFloat(this.feeForm.month7)
				}
			},
			targetFeeKeyup8() {
				this.feeForm.month8 = this.feeForm.month8.replace(/[^0-9.]/g, "")
				if (this.feeForm.month8.indexOf('.') < 0 && this.feeForm.month8 != '') {
					this.feeForm.month8 = parseFloat(this.feeForm.month8)
				}
			},
			targetFeeKeyup9() {
				this.feeForm.month9 = this.feeForm.month9.replace(/[^0-9.]/g, "")
				if (this.feeForm.month9.indexOf('.') < 0 && this.feeForm.month9 != '') {
					this.feeForm.month9 = parseFloat(this.feeForm.month9)
				}
			},
			targetFeeKeyup10() {
				this.feeForm.month10 = this.feeForm.month10.replace(/[^0-9.]/g, "")
				if (this.feeForm.month10.indexOf('.') < 0 && this.feeForm.month10 != '') {
					this.feeForm.month10 = parseFloat(this.feeForm.month10)
				}
			},
			targetFeeKeyup11() {
				this.feeForm.month11 = this.feeForm.month11.replace(/[^0-9.]/g, "")
				if (this.feeForm.month11.indexOf('.') < 0 && this.feeForm.month11 != '') {
					this.feeForm.month11 = parseFloat(this.feeForm.month11)
				}
			},
			targetFeeKeyup12() {
				this.feeForm.month12 = this.feeForm.month12.replace(/[^0-9.]/g, "")
				if (this.feeForm.month12.indexOf('.') < 0 && this.feeForm.month12 != '') {
					this.feeForm.month12 = parseFloat(this.feeForm.month12)
				}
			},
      targetKeyup1() {
				// 仅保留数字和"."
				this.form.month1 = this.form.month1.replace(/[^0-9.]/g, "")
				// 首位是0的话去掉
				if (this.form.month1.indexOf('.') < 0 && this.form.month1 != '') {
					this.form.month1 = parseFloat(this.form.month1)
				}
			},
			targetKeyup2() {
				this.form.month2 = this.form.month2.replace(/[^0-9.]/g, "")
				if (this.form.month2.indexOf('.') < 0 && this.form.month2 != '') {
					this.form.month2 = parseFloat(this.form.month2)
				}
			},
			targetKeyup3() {
				this.form.month3 = this.form.month3.replace(/[^0-9.]/g, "")
				if (this.form.month3.indexOf('.') < 0 && this.form.month3 != '') {
					this.form.month3 = parseFloat(this.form.month3)
				}
			},
			targetKeyup4() {
				this.form.month4 = this.form.month4.replace(/[^0-9.]/g, "")
				if (this.form.month4.indexOf('.') < 0 && this.form.month4 != '') {
					this.form.month4 = parseFloat(this.form.month4)
				}
			},
			targetKeyup5() {
				this.form.month5 = this.form.month5.replace(/[^0-9.]/g, "")
				if (this.form.month5.indexOf('.') < 0 && this.form.month5 != '') {
					this.form.month5 = parseFloat(this.form.month5)
				}
			},
			targetKeyup6() {
				this.form.month6 = this.form.month6.replace(/[^0-9.]/g, "")
				if (this.form.month6.indexOf('.') < 0 && this.form.month6 != '') {
					this.form.month6 = parseFloat(this.form.month6)
				}
			},
			targetKeyup7() {
				this.form.month7 = this.form.month7.replace(/[^0-9.]/g, "")
				if (this.form.month7.indexOf('.') < 0 && this.form.month7 != '') {
					this.form.month7 = parseFloat(this.form.month7)
				}
			},
			targetKeyup8() {
				this.form.month8 = this.form.month8.replace(/[^0-9.]/g, "")
				if (this.form.month8.indexOf('.') < 0 && this.form.month8 != '') {
					this.form.month8 = parseFloat(this.form.month8)
				}
			},
			targetKeyup9() {
				this.form.month9 = this.form.month9.replace(/[^0-9.]/g, "")
				if (this.form.month9.indexOf('.') < 0 && this.form.month9 != '') {
					this.form.month9 = parseFloat(this.form.month9)
				}
			},
			targetKeyup10() {
				this.form.month10 = this.form.month10.replace(/[^0-9.]/g, "")
				if (this.form.month10.indexOf('.') < 0 && this.form.month10 != '') {
					this.form.month10 = parseFloat(this.form.month10)
				}
			},
			targetKeyup11() {
				this.form.month11 = this.form.month11.replace(/[^0-9.]/g, "")
				if (this.form.month11.indexOf('.') < 0 && this.form.month11 != '') {
					this.form.month11 = parseFloat(this.form.month11)
				}
			},
			targetKeyup12() {
				this.form.month12 = this.form.month12.replace(/[^0-9.]/g, "")
				if (this.form.month12.indexOf('.') < 0 && this.form.month12 != '') {
					this.form.month12 = parseFloat(this.form.month12)
				}
			},
      // 获取一年后日期
      getTime() {
        var date = new Date()
        var year = date.getFullYear() + 1
        var month = (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        var day = (date.getDate()) > 9 ? date.getDate() : '0' + date.getDate()
        var dateFormat = year + '/' + month + '/' + day
        var date1 = new Date(dateFormat)
        var time = date1.getTime()
        return time
      },
      // 获取30天后日期
      getThirtyTime() {
        var date = new Date()
        var year = date.getFullYear()
        var month = (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        var day = (date.getDate()) > 9 ? date.getDate() : '0' + date.getDate()
        var dateFormat = year + '/' + month + '/' + day
        var date1 = new Date(dateFormat)
        var time = date1.getTime() + 30 * 24 * 60 * 60 * 1000
        return time
      },
      handleClick(tab, event) {
        console.log(tab, event)
      },
      separate() {
        // flag=1为添加小区
        if (this.flag == 1) {
          this.isAddTrue = false
          this.isTrue = true
          this.ruleForm.name = ''
          this.ruleForm.provinces = 110000 // 默认为北京市
          this.ruleForm.onlyOpenDoor = '1'
          this.ruleForm.adFlag = '0'
		  this.ruleForm.openCredit = '0'
          this.ruleForm.isDisplay = ''
          this.ruleForm.gardenCode = ''
		  this.ruleForm.sortId = 0
          this.ruleForm.parkCode = ''
          this.ruleForm.cityId = ''
          this.selectcity(this.ruleForm.provinces) // 默认为北京市
        }
        if (this.flag == 0) {
          // flag=0为修改小区 
          this.id = this.$route.query.id
          this.ruleForm = this.$route.query
          this.ruleForm.gardenLogo = this.$route.query.gardenLogo
          this.ruleForm.qrcodeImgUrl = this.$route.query.qrcodeImgUrl
          this.ruleForm.longitude = this.$route.query.longitude
          this.ruleForm.latitude = this.$route.query.latitude
          this.ruleForm.affiliatedCompany = this.$route.query.affiliatedCompany || ''
          this.ruleForm.projectCode = this.$route.query.projectCode || ''
          this.ruleForm.themeColor = this.$route.query.themeColor
          this.ruleForm.complainUrl = this.$route.query.complainUrl
          this.ruleForm.gardenArea = this.$route.query.gardenArea
          this.ruleForm.sortId = this.$route.query.sortId
          this.$nextTick(function () {
						this.creatQrCode()
					})
          if (this.ruleForm.gardenLogo) {
            this.fileList.push({
              name: '',
              url: this.$route.query.gardenLogo
            })
          } else {
            this.fileList = []
          }
          if (this.ruleForm.qrcodeImgUrl) {
            this.fileList1.push({
              name: '',
              url: this.$route.query.qrcodeImgUrl
            })
          } else {
            this.fileList1 = []
          }
          this.filesList2 = []
          this.fileList2 = []
          if (this.$route.query.urls && this.$route.query.urls.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls.length; i++) {
              console.log(this.$route.query.urls[i])
              this.filesList2.push({
                name: this.$route.query.urls[i].split('|')[1],
                url: this.$route.query.urls[i].split('|')[0]
              })
              this.fileList2.push({
                name: this.$route.query.urls[i].split('|')[1],
                url: this.$route.query.urls[i].split('|')[0]
              })
            }
          }
          this.filesList3 = []
          this.fileList3 = []
          if (this.$route.query.urls3 && this.$route.query.urls3.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls3.length; i++) {
              console.log(this.$route.query.urls3[i])
              this.filesList3.push({
                name: this.$route.query.urls3[i].split('|')[1],
                url: this.$route.query.urls3[i].split('|')[0]
              })
              this.fileList3.push({
                name: this.$route.query.urls3[i].split('|')[1],
                url: this.$route.query.urls3[i].split('|')[0]
              })
            }
          }
          this.filesList4 = []
          this.fileList4 = []
          if (this.$route.query.urls4 && this.$route.query.urls4.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls4.length; i++) {
              console.log(this.$route.query.urls4[i])
              this.filesList4.push({
                name: this.$route.query.urls4[i].split('|')[1],
                url: this.$route.query.urls4[i].split('|')[0]
              })
              this.fileList4.push({
                name: this.$route.query.urls4[i].split('|')[1],
                url: this.$route.query.urls4[i].split('|')[0]
              })
            }
          }
          this.filesList5 = []
          this.fileList5 = []
          if (this.$route.query.urls5 && this.$route.query.urls5.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls5.length; i++) {
              console.log(this.$route.query.urls5[i])
              this.filesList5.push({
                name: this.$route.query.urls5[i].split('|')[1],
                url: this.$route.query.urls5[i].split('|')[0]
              })
              this.fileList5.push({
                name: this.$route.query.urls5[i].split('|')[1],
                url: this.$route.query.urls5[i].split('|')[0]
              })
            }
          }
          this.filesList6 = []
          this.fileList6 = []
          if (this.$route.query.urls6 && this.$route.query.urls6.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls6.length; i++) {
              console.log(this.$route.query.urls6[i])
              this.filesList6.push({
                name: this.$route.query.urls6[i].split('|')[1],
                url: this.$route.query.urls6[i].split('|')[0]
              })
              this.fileList6.push({
                name: this.$route.query.urls6[i].split('|')[1],
                url: this.$route.query.urls6[i].split('|')[0]
              })
            }
          }
          this.filesList7 = []
          this.fileList7 = []
          if (this.$route.query.urls7 && this.$route.query.urls7.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls7.length; i++) {
              console.log(this.$route.query.urls7[i])
              this.filesList7.push({
                name: this.$route.query.urls7[i].split('|')[1],
                url: this.$route.query.urls7[i].split('|')[0]
              })
              this.fileList7.push({
                name: this.$route.query.urls7[i].split('|')[1],
                url: this.$route.query.urls7[i].split('|')[0]
              })
            }
          }
          this.filesList8 = []
          this.fileList8 = []
          if (this.$route.query.urls8 && this.$route.query.urls8.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls8.length; i++) {
              console.log(this.$route.query.urls8[i])
              this.filesList8.push({
                name: this.$route.query.urls8[i].split('|')[1],
                url: this.$route.query.urls8[i].split('|')[0]
              })
              this.fileList8.push({
                name: this.$route.query.urls8[i].split('|')[1],
                url: this.$route.query.urls8[i].split('|')[0]
              })
            }
          }
          this.filesList9 = []
          this.fileList9 = []
          if (this.$route.query.urls9 && this.$route.query.urls9.length > 0) {
            console.log(1)
            for (let i = 0; i < this.$route.query.urls9.length; i++) {
              console.log(this.$route.query.urls9[i])
              this.filesList9.push({
                name: this.$route.query.urls9[i].split('|')[1],
                url: this.$route.query.urls9[i].split('|')[0]
              })
              this.fileList9.push({
                name: this.$route.query.urls9[i].split('|')[1],
                url: this.$route.query.urls9[i].split('|')[0]
              })
            }
          }
          this.filesList10 = []
          this.fileList10 = []
          if (this.$route.query.gardenPhoto && this.$route.query.gardenPhoto.length > 0) {
            let resUrls = this.$route.query.gardenPhoto.split(',')
            for (let i = 0; i < resUrls.length; i++) {
              this.fileList10.push({
                name: '',
                url: resUrls[i]
              })
            }
          }
          this.filesList10 = JSON.parse(JSON.stringify(this.fileList10))
          // this.id = this.ruleForm.id
          this.saveData = JSON.stringify(this.ruleForm)

          // this.ruleForm.onlyOpenDoor = this.ruleForm.onlyOpenDoor.toString()
          // this.ruleForm.isDisplay = this.ruleForm.isDisplay.toString()
          // this.ruleForm.adFlag = this.ruleForm.adFlag.toString()
          console.log(this.ruleForm.mixExitCount)
        }
      },
      getFileGardenPhoto(e) {
        this.fileList10.push({
          name: '',
          url: e
        })
      },
      removeFileGardenPhoto(e) {
        let list1 = []
        for (let i = 0; i < this.fileList10.length; i++) {
          if (this.fileList10[i] === e || (this.fileList10[i].url && this.fileList10[i].url === e)) {

          } else {
            list1.push(this.fileList10[i])
          }
        }
        this.fileList10 = list1
        this.ruleForm.gardenPhoto = this.fileList10
        this.filesList10 = JSON.parse(JSON.stringify(list1))
      },
      // 获取组件值
      getFile(e) {
        this.ruleForm.gardenLogo = e
        this.$refs.gardenLogo.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.gardenLogo = ''
      },
      // 获取组件值
      getFile2(e, f) {
        this.fileList2.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile3(e, f) {
        this.fileList3.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile4(e, f) {
        this.fileList4.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile5(e, f) {
        this.fileList5.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile6(e, f) {
        this.fileList6.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile7(e, f) {
        this.fileList7.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile8(e, f) {
        this.fileList8.push({
          name: f,
          url: e
        })
      },
      // 获取组件值
      getFile9(e, f) {
        this.fileList9.push({
          name: f,
          url: e
        })
      },
      // 移除图片
      removeFile2(e) {
        let list1 = []
        for (let i = 0; i < this.fileList2.length; i++) {
          if (this.fileList2[i].url === e) {

          } else {
            list1.push(this.fileList2[i])
          }
        }
        this.fileList2 = list1
        this.filesList2 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile3(e) {
        let list1 = []
        for (let i = 0; i < this.fileList3.length; i++) {
          if (this.fileList3[i].url === e) {

          } else {
            list1.push(this.fileList3[i])
          }
        }
        this.fileList3 = list1
        this.filesList3 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile4(e) {
        let list1 = []
        for (let i = 0; i < this.fileList4.length; i++) {
          if (this.fileList4[i].url === e) {

          } else {
            list1.push(this.fileList4[i])
          }
        }
        this.fileList4 = list1
        this.filesList4 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile5(e) {
        let list1 = []
        for (let i = 0; i < this.fileList5.length; i++) {
          if (this.fileList5[i].url === e) {

          } else {
            list1.push(this.fileList5[i])
          }
        }
        this.fileList5 = list1
        this.filesList5 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile6(e) {
        let list1 = []
        for (let i = 0; i < this.fileList6.length; i++) {
          if (this.fileList6[i].url === e) {

          } else {
            list1.push(this.fileList6[i])
          }
        }
        this.fileList6 = list1
        this.filesList6 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile7(e) {
        let list1 = []
        for (let i = 0; i < this.fileList7.length; i++) {
          if (this.fileList7[i].url === e) {

          } else {
            list1.push(this.fileList7[i])
          }
        }
        this.fileList7 = list1
        this.filesList7 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile8(e) {
        let list1 = []
        for (let i = 0; i < this.fileList8.length; i++) {
          if (this.fileList8[i].url === e) {

          } else {
            list1.push(this.fileList8[i])
          }
        }
        this.fileList8 = list1
        this.filesList8 = JSON.parse(JSON.stringify(list1))
      },
      // 移除图片
      removeFile9(e) {
        let list1 = []
        for (let i = 0; i < this.fileList9.length; i++) {
          if (this.fileList9[i].url === e) {

          } else {
            list1.push(this.fileList9[i])
          }
        }
        this.fileList9 = list1
        this.filesList9 = JSON.parse(JSON.stringify(list1))
      },
      // 收款码获取组件值
      getFile1(e) {
        console.log(e)
        this.ruleForm.qrcodeImgUrl = e
        this.$refs.qrcodeImgUrl.clearValidate()
      },
      // 收款码移除图片
      removeFile1(e) {
        this.fileList1 = []
        this.ruleForm.qrcodeImgUrl = ''
      },
      handleChange(value) {
        console.log(value)
      },
      // 根据城市id确定省份
      findProvince() {
        let that = this
        this.cities.forEach((item, index) => {
          if (item.items) {
            item.items.forEach((itt, idx) => {
              if (itt.items) {
                itt.items.forEach((iit, ix) => {
                  if (that.ruleForm.cityId == itt.id || that.ruleForm.cityId == iit.id) {
                    that.ruleForm.provinces = item.id
                    that.choosecity = item.items
                  }
                })
              }
            })
          }
        })
      },
      // 根据id不同显示不同城市
      choosecitys(id) {
        this.ruleForm.cityId = id
        console.log(this.ruleForm.cityId)
      },
      // 根据省份选择城市
      selectcity(id) {
        for (var i = 0; i < this.cities.length; i++) {
          if (this.cities[i].id == id) {
            this.ruleForm.cityId = ''
            this.choosecity = []
            this.choosecity = this.cities[i].items
            this.ruleForm.cityId = this.cities[i].items[0].id
          }
        }
      },
      // 跳转到业主App广告管理
      jump() {
        this.$router.push({
          name: 'communityManagementsList'
        })
      },
      // 保存按钮事件
      onSubmit() {
        // let loading = this.$loading()
        if (this.flag == 1) {
          let g = ''
          if (this.ruleForm.gardenLogoType == '0') {
            g = 'http://zhwyjk.kmyhwy.cn/wxcode/logo/mr1.png'
          } else if (this.ruleForm.gardenLogoType == '1') {
            g = this.ruleForm.gardenLogo
          } else if (this.ruleForm.gardenLogoType == '2') {
            g = ''
          } else {
            g = ''
          }
          if (this.fileList2.length > 0) {
            for (let i = 0; i < this.fileList2.length; i++) {
              if (this.fileList2[i].url.indexOf('blob') != -1) {
                this.filesList2.push(this.fileList2[i].response.data[0])
              } else {
                this.filesList2.push(this.fileList2[i].url)
              }
            }
          }
          if (this.fileList3.length > 0) {
            for (let i = 0; i < this.fileList3.length; i++) {
              if (this.fileList3[i].url.indexOf('blob') != -1) {
                this.filesList3.push(this.fileList3[i].response.data[0])
              } else {
                this.filesList3.push(this.fileList3[i].url)
              }
            }
          }
          if (this.fileList4.length > 0) {
            for (let i = 0; i < this.fileList4.length; i++) {
              if (this.fileList4[i].url.indexOf('blob') != -1) {
                this.filesList4.push(this.fileList4[i].response.data[0])
              } else {
                this.filesList4.push(this.fileList4[i].url)
              }
            }
          }
          if (this.fileList5.length > 0) {
            for (let i = 0; i < this.fileList5.length; i++) {
              if (this.fileList5[i].url.indexOf('blob') != -1) {
                this.filesList5.push(this.fileList5[i].response.data[0])
              } else {
                this.filesList5.push(this.fileList5[i].url)
              }
            }
          }
          if (this.fileList6.length > 0) {
            for (let i = 0; i < this.fileList6.length; i++) {
              if (this.fileList6[i].url.indexOf('blob') != -1) {
                this.filesList6.push(this.fileList6[i].response.data[0])
              } else {
                this.filesList6.push(this.fileList6[i].url)
              }
            }
          }
          if (this.fileList7.length > 0) {
            for (let i = 0; i < this.fileList7.length; i++) {
              if (this.fileList7[i].url.indexOf('blob') != -1) {
                this.filesList7.push(this.fileList7[i].response.data[0])
              } else {
                this.filesList7.push(this.fileList7[i].url)
              }
            }
          }
          if (this.fileList8.length > 0) {
            for (let i = 0; i < this.fileList8.length; i++) {
              if (this.fileList8[i].url.indexOf('blob') != -1) {
                this.filesList8.push(this.fileList8[i].response.data[0])
              } else {
                this.filesList8.push(this.fileList8[i].url)
              }
            }
          }
          if (this.fileList9.length > 0) {
            for (let i = 0; i < this.fileList9.length; i++) {
              if (this.fileList9[i].url.indexOf('blob') != -1) {
                this.filesList9.push(this.fileList9[i].response.data[0])
              } else {
                this.filesList9.push(this.fileList9[i].url)
              }
            }
          }
          if (this.fileList10.length > 0) {
            for (let i = 0; i < this.fileList10.length; i++) {
              if (this.fileList10[i].url.indexOf('blob') != -1) {
                this.filesList10.push(this.fileList10[i].response.data[0])
              } else {
                this.filesList10.push(this.fileList10[i].url)
              }
            }
          }
          let params = {
            'name': this.ruleForm.name,
            'cityId': this.ruleForm.cityId,
            'onlyOpenDoor': this.ruleForm.onlyOpenDoor,
            'gardenCode': this.ruleForm.gardenCode ? this.ruleForm.gardenCode : '',
            'sortId': this.ruleForm.sortId ? this.ruleForm.sortId : 0,
            'parkCode': this.ruleForm.parkCode ? this.ruleForm.parkCode : '',
            'isDisplay': this.ruleForm.isDisplay ? this.ruleForm.isDisplay : '',
            'isLiftControl': this.ruleForm.isLiftControl ? this.ruleForm.isLiftControl : '',
            'isShareDoor': this.ruleForm.isShareDoor ? this.ruleForm.isShareDoor : '',
            'isShareLift': this.ruleForm.isShareLift ? this.ruleForm.isShareLift : '',
            'gardenLogoType': this.ruleForm.gardenLogoType ? this.ruleForm.gardenLogoType : '',
            'gardenLogo': g,
            'qrcodeImgUrl': this.ruleForm.qrcodeImgUrl ? this.ruleForm.qrcodeImgUrl : '',
            'adFlag': this.ruleForm.adFlag ? this.ruleForm.adFlag : '',
            'openCredit': this.ruleForm.openCredit ? this.ruleForm.openCredit : '',
            'files3': this.filesList3.toString(),
            'files4': this.filesList4.toString(),
            'files5': this.filesList5.toString(),
            'files6': this.filesList6.toString(),
            'files7': this.filesList7.toString(),
            'files8': this.filesList8.toString(),
            'files9': this.filesList9.toString(),
            'files': this.filesList2.toString(),
            'gardenPhoto': this.filesList10.toString(),
            'gardenInfo': this.ruleForm.gardenInfo,
            'floorArea': this.ruleForm.floorArea,
            'coverArea': this.ruleForm.coverArea,
            'onGroundArea': this.ruleForm.onGroundArea,
            'unGroundArea': this.ruleForm.unGroundArea,
            'feeArea': this.ruleForm.feeArea,
            'outletsCount': this.ruleForm.outletsCount,
            'venueCount': this.ruleForm.venueCount,
            'deviceCount': this.ruleForm.deviceCount,
            'staffNum': this.ruleForm.staffNum,
            'buildingsCount': this.ruleForm.buildingsCount,
            'unitsCount': this.ruleForm.unitsCount,
            'peoExitCount': this.ruleForm.peoExitCount,
            'nopeoExitCount': this.ruleForm.nopeoExitCount,
            'carExitCount': this.ruleForm.carExitCount,
            'mixExitCount': this.ruleForm.mixExitCount,
            'houseHolds': this.ruleForm.houseHolds,
            'liftCount': this.ruleForm.liftCount,
            'parkCount': this.ruleForm.parkCount,
            'feePrice': this.ruleForm.feePrice,
            'feeParkPrice': this.ruleForm.feeParkPrice,
            'deliverDateL': this.ruleForm.deliverDateL,
            'gardenValidL': this.ruleForm.gardenValid,
            'gardenDeleteValidLong': this.ruleForm.gardenDeleteValid,
            'longitude': this.ruleForm.longitude,
            'latitude': this.ruleForm.latitude,
            'affiliatedCompany': this.ruleForm.affiliatedCompany,
            'projectCode': this.ruleForm.projectCode,
            'themeColor': this.ruleForm.themeColor,
            'gardenArea': this.ruleForm.gardenArea,
          }
          this.$refs['addApp'].validate((valid) => {
            // loading.close()
            if (valid) {
              this.$post('/gardens', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.eagleEye.addSucceed')
                  })
                  this.$router.push({
                    name: 'communityManagementsList'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        } else if (this.flag == 0) {
          let g = ''
          if (this.ruleForm.gardenLogoType == '0') {
            g = 'http://zhwyjk.kmyhwy.cn/wxcode/logo/mr1.png'
          } else if (this.ruleForm.gardenLogoType == '1') {
            g = this.ruleForm.gardenLogo
          } else if (this.ruleForm.gardenLogoType == '2') {
            g = ''
          } else {
            g = ''
          }
          if (this.fileList2.length > 0) {
            for (let i = 0; i < this.fileList2.length; i++) {
              if (this.fileList2[i].url.indexOf('blob') != -1) {
                this.filesList2.push(this.fileList2[i].response.data[0])
              } else {
                this.filesList2.push(this.fileList2[i].url)
              }
            }
          }
          if (this.fileList3.length > 0) {
            for (let i = 0; i < this.fileList3.length; i++) {
              if (this.fileList3[i].url.indexOf('blob') != -1) {
                this.filesList3.push(this.fileList3[i].response.data[0])
              } else {
                this.filesList3.push(this.fileList3[i].url)
              }
            }
          }
          if (this.fileList4.length > 0) {
            for (let i = 0; i < this.fileList4.length; i++) {
              if (this.fileList4[i].url.indexOf('blob') != -1) {
                this.filesList4.push(this.fileList4[i].response.data[0])
              } else {
                this.filesList4.push(this.fileList4[i].url)
              }
            }
          }
          if (this.fileList5.length > 0) {
            for (let i = 0; i < this.fileList5.length; i++) {
              if (this.fileList5[i].url.indexOf('blob') != -1) {
                this.filesList5.push(this.fileList5[i].response.data[0])
              } else {
                this.filesList5.push(this.fileList5[i].url)
              }
            }
          }
          if (this.fileList6.length > 0) {
            for (let i = 0; i < this.fileList6.length; i++) {
              if (this.fileList6[i].url.indexOf('blob') != -1) {
                this.filesList6.push(this.fileList6[i].response.data[0])
              } else {
                this.filesList6.push(this.fileList6[i].url)
              }
            }
          }
          if (this.fileList7.length > 0) {
            for (let i = 0; i < this.fileList7.length; i++) {
              if (this.fileList7[i].url.indexOf('blob') != -1) {
                this.filesList7.push(this.fileList7[i].response.data[0])
              } else {
                this.filesList7.push(this.fileList7[i].url)
              }
            }
          }
          if (this.fileList8.length > 0) {
            for (let i = 0; i < this.fileList8.length; i++) {
              if (this.fileList8[i].url.indexOf('blob') != -1) {
                this.filesList8.push(this.fileList8[i].response.data[0])
              } else {
                this.filesList8.push(this.fileList8[i].url)
              }
            }
          }
          if (this.fileList9.length > 0) {
            for (let i = 0; i < this.fileList9.length; i++) {
              if (this.fileList9[i].url.indexOf('blob') != -1) {
                this.filesList9.push(this.fileList9[i].response.data[0])
              } else {
                this.filesList9.push(this.fileList9[i].url)
              }
            }
          }
          if (this.fileList10.length > 0) {
            this.filesList10 = []
            for (let i = 0; i < this.fileList10.length; i++) {
              if (this.fileList10[i].url.indexOf('blob') != -1) {
                this.filesList10.push(this.fileList10[i].response.data[0])
              } else {
                this.filesList10.push(this.fileList10[i].url)
              }
            }
          }
          let params = {
            'name': this.ruleForm.name,
            'cityId': this.ruleForm.cityId,
            'onlyOpenDoor': this.ruleForm.onlyOpenDoor,
            'gardenCode': this.ruleForm.gardenCode,
            'sortId': this.ruleForm.sortId,
            'parkCode': this.ruleForm.parkCode,
            'isDisplay': this.ruleForm.isDisplay,
            'isLiftControl': this.ruleForm.isLiftControl,
            'isShareDoor': this.ruleForm.isShareDoor,
            'isShareLift': this.ruleForm.isShareLift,
            'gardenLogoType': this.ruleForm.gardenLogoType,
            'adFlag': this.ruleForm.adFlag,
            'openCredit': this.ruleForm.openCredit,
            'gardenLogo': g,
            'qrcodeImgUrl': this.ruleForm.qrcodeImgUrl ? this.ruleForm.qrcodeImgUrl : '',
            'files3': this.filesList3.toString(),
            'files4': this.filesList4.toString(),
            'files5': this.filesList5.toString(),
            'files6': this.filesList6.toString(),
            'files7': this.filesList7.toString(),
            'files8': this.filesList8.toString(),
            'files9': this.filesList9.toString(),
            'files': this.filesList2.toString(),
            'gardenPhoto': this.filesList10.toString(),
            'gardenInfo': this.ruleForm.gardenInfo,
            'floorArea': this.ruleForm.floorArea,
            'coverArea': this.ruleForm.coverArea,
            'onGroundArea': this.ruleForm.onGroundArea,
            'unGroundArea': this.ruleForm.unGroundArea,
            'feeArea': this.ruleForm.feeArea,
            'outletsCount': this.ruleForm.outletsCount,
            'venueCount': this.ruleForm.venueCount,
            'deviceCount': this.ruleForm.deviceCount,
            'staffNum': this.ruleForm.staffNum,
            'buildingsCount': this.ruleForm.buildingsCount,
            'unitsCount': this.ruleForm.unitsCount,
            'peoExitCount': this.ruleForm.peoExitCount,
            'nopeoExitCount': this.ruleForm.nopeoExitCount,
            'carExitCount': this.ruleForm.carExitCount,
            'mixExitCount': this.ruleForm.mixExitCount,
            'houseHolds': this.ruleForm.houseHolds,
            'liftCount': this.ruleForm.liftCount,
            'parkCount': this.ruleForm.parkCount,
            'feePrice': this.ruleForm.feePrice,
            'feeParkPrice': this.ruleForm.feeParkPrice,
            'deliverDateL': this.ruleForm.deliverDateL,
            'gardenValidL': this.ruleForm.gardenValid,
            'gardenDeleteValidLong': this.ruleForm.gardenDeleteValid,
            'longitude': this.ruleForm.longitude,
            'latitude': this.ruleForm.latitude,
            'affiliatedCompany': this.ruleForm.affiliatedCompany,
            'projectCode': this.ruleForm.projectCode,
            'themeColor': this.ruleForm.themeColor,
            'gardenArea': this.ruleForm.gardenArea,
          }
          this.$refs['addApp'].validate((valid) => {
            // loading.close()
            if (valid) {
              // this.$confirm(this.$i18n.t('lang.eagleEye.sureChange'), this.$i18n.t('lang.lab_prompt'), {
              //   confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              //   cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              //   type: 'warning'
              // }).then(() => {
              this.$patch(`/gardens/${this.id}`, params).then(res => {
                if (res.errCode == 0) {
                  if (this.form.targetYear && this.form.targetYear != undefined && this.form.targetYear != '') {
										/* 员工目标值 */
										let date = new Date(this.form.targetYear)
										let year = date.getFullYear()
										this.$post(`/feeGardenTarget`, {
											gardenId: this.id,
											targetYear: year,
                      type:1,
											targetAmount1: this.form.month1 == '' ? 0 : this.form
												.month1,
											targetAmount2: this.form.month2 == '' ? 0 : this.form
												.month2,
											targetAmount3: this.form.month3 == '' ? 0 : this.form
												.month3,
											targetAmount4: this.form.month4 == '' ? 0 : this.form
												.month4,
											targetAmount5: this.form.month5 == '' ? 0 : this.form
												.month5,
											targetAmount6: this.form.month6 == '' ? 0 : this.form
												.month6,
											targetAmount7: this.form.month7 == '' ? 0 : this.form
												.month7,
											targetAmount8: this.form.month8 == '' ? 0 : this.form
												.month8,
											targetAmount9: this.form.month9 == '' ? 0 : this.form
												.month9,
											targetAmount10: this.form.month10 == '' ? 0 : this.form
												.month10,
											targetAmount11: this.form.month11 == '' ? 0 : this.form
												.month11,
											targetAmount12: this.form.month12 == '' ? 0 : this.form
												.month12,
										}).then(res => {
											console.log('目标值提交成功')
										}, err => {
											this.$message.error(err)
										})
									}
                  if (this.form.targetYear && this.feeForm.targetYear != undefined && this.form.targetYear != '') {
										/* 员工收费目标值 */
										let date = new Date(this.feeForm.targetYear)
										let year = date.getFullYear()
										this.$post(`/feeGardenTarget`, {
											gardenId: this.id,
											targetYear: year,
                      type:2,
											targetAmount1: this.feeForm.month1 == '' ? 0 : this.feeForm
												.month1,
											targetAmount2: this.feeForm.month2 == '' ? 0 : this.feeForm
												.month2,
											targetAmount3: this.feeForm.month3 == '' ? 0 : this.feeForm
												.month3,
											targetAmount4: this.feeForm.month4 == '' ? 0 : this.feeForm
												.month4,
											targetAmount5: this.feeForm.month5 == '' ? 0 : this.feeForm
												.month5,
											targetAmount6: this.feeForm.month6 == '' ? 0 : this.feeForm
												.month6,
											targetAmount7: this.feeForm.month7 == '' ? 0 : this.feeForm
												.month7,
											targetAmount8: this.feeForm.month8 == '' ? 0 : this.feeForm
												.month8,
											targetAmount9: this.feeForm.month9 == '' ? 0 : this.feeForm
												.month9,
											targetAmount10: this.feeForm.month10 == '' ? 0 : this.feeForm
												.month10,
											targetAmount11: this.feeForm.month11 == '' ? 0 : this.feeForm
												.month11,
											targetAmount12: this.feeForm.month12 == '' ? 0 : this.feeForm
												.month12,
										}).then(res => {
											console.log('目标值提交成功')
										}, err => {
											this.$message.error(err)
										})
									}
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                  this.$router.push({
                    name: 'communityManagementsList'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
              // })
            } else {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('lang.eagleEye.subfail')
              })
              return false
            }
          })
        } else {}
      },
      resetForm() {
        this.$refs.addApp.clearValidate()
        this.name = ''
        this.provinces = ''
        this.cityItem = ''
        this.parkCode = ''
        this.isDisplay = ''
        this.ruleForm.name = '' // this.$i18n.t('lang.housearea.newName') ''
        this.ruleForm.provinces = 110000 // 杜，省份默认为北京
        this.ruleForm.cityItem = ''
        this.ruleForm.cityId = ''
        this.ruleForm.gardenCode = '' // 杜，小区编码
        this.ruleForm.sortId = 0
        this.ruleForm.parkCode = '' // 杜，停车场编码
        this.ruleForm.onlyOpenDoor = '1' // 杜，开门权限正常
        this.ruleForm.isDisplay = ''
        this.ruleForm.isLiftControl = '1'
        this.ruleForm.isShareDoor = '1'
        this.ruleForm.isShareLift = '1'
        this.ruleForm.gardenLogoType = '0'
        this.selectcity(this.ruleForm.provinces) // 默认为北京市
        this.fileList1 = [] // 清空收款码
        this.fileList2 = []
        this.fileList3 = []
        this.fileList4 = []
        this.fileList5 = []
        this.fileList6 = []
        this.fileList7 = []
        this.fileList8 = []
        this.fileList9 = []
        this.fileList10 = []
        this.ruleForm.longitude = ''
        this.ruleForm.latitude = ''
        this.ruleForm.affiliatedCompany = ''
        this.ruleForm.projectCode = ''
        this.ruleForm.themeColor = this.flag == 0 ? this.$route.query.themeColor : '#365c9d'
        this.ruleForm.gardenPhoto = []
        this.ruleForm.gardenInfo = ''
        this.ruleForm.floorArea = ''
        this.ruleForm.coverArea = ''
        this.ruleForm.onGroundArea = ''
        this.ruleForm.unGroundArea = ''
        this.ruleForm.feeArea = ''
        this.ruleForm.outletsCount = ''
        this.ruleForm.venueCount = ''
        this.ruleForm.deviceCount = ''
        this.ruleForm.staffNum = ''
        this.ruleForm.buildingsCount = ''
        this.ruleForm.unitsCount = ''
        this.ruleForm.peoExitCount = ''
        this.ruleForm.nopeoExitCount = ''
        this.ruleForm.carExitCount = ''
        this.ruleForm.mixExitCount = ''
        this.ruleForm.houseHolds = ''
        this.ruleForm.liftCount = ''
        this.ruleForm.parkCount = ''
        this.ruleForm.feePrice = ''
        this.ruleForm.feeParkPrice = ''
        this.ruleForm.deliverDateL = ''
        this.ruleForm.gardenValid = this.getTime()
        this.ruleForm.gardenDeleteValid = this.getThirtyTime()
        this.ruleForm.gardenArea = ''
      },
      // 2位小数
      handleInputDec(value, name) {
        this.ruleForm[name] = value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
      },
      // 整数
      handleInputInt(value, name) {
        this.ruleForm[name] = value.replace(/[^0-9]/g, '')
        // this.ruleForm[name] = value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      },
      // 恢复自定义颜色为默认值
      restoreDefaultThemeColor() {
        this.ruleForm.themeColor = '#365c9d'
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            this.isCanUse = true
          } else {
            // 变了
            this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.themeColor': {
        handler(newColor, oldColor) {
          console.log('主题色已变更:', '旧颜色:', oldColor, '新颜色:', newColor);
        },
        immediate: true,
        deep: false
      }
    },
  }
</script>

<style lang="scss">
  .OwnerAppadvertisingadd {
    .select {
      width: 833px;
      margin-left: 0px !important;
    }

    .el-input-number {
      width: 833px !important;
    }

    .el-upload-dragger {
      width: 833px !important;
    }

    .qrcodeImg .el-upload-list,
    .qrcodeImg .el-upload-list--picture {
      display: inline-block;
    }

    .el-upload-list,
    .el-upload-list--picture {
      display: flex;
      flex-wrap: wrap !important;
      // overflow: hidden!important;
      // text-overflow: ellipsis!important;
      // -webkit-line-clamp: 3!important;
      // -webkit-box-orient: vertical!important;
      // line-height: 1.5!important;
      // white-space: normal!important;
    }

    .el-upload-list__item-name {
      margin-top: 0 !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      -webkit-line-clamp: 3 !important;
      -webkit-box-orient: vertical !important;
      line-height: 1.6 !important;
      white-space: normal !important;
      display: -webkit-box !important;
      word-wrap: break-word !important;
    }

    .el-upload-list__item {
      // width: auto;
      max-width: 300px;
      margin-right: 20px;
    }

    .el-tabs {
      background-color: #fff !important;
    }

    .el-tabs__nav-wrap {
      width: 100% !important;
      max-width: 100% !important;
      position: static !important;
      background-color: #fff !important;
      padding-left: 35px !important;
      margin-bottom: 20px !important;
      box-sizing: border-box;
    }

    .el-tabs__content {
      background-color: #fff !important;
    }

    .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .garden .targetMonth {
		width: 200px;
	}
	
	.targetLabel {
		margin: 10px;
		display: inline-block;
	}
  .qrcode {
			display: inline-block;

			img {
				width: 132px;
				height: 132px;
				border: 1px solid #999;
				background-color: #fff; //设置白色背景色
				padding: 6px; // 利用padding的特性，挤出白边
				box-sizing: border-box;
			}
		}
  }
</style>